/* ----------------------------------------
    AI Assistant Panel
---------------------------------------- */

export class AIAssistantPanel {
    constructor() {
        this._panel = document.querySelector('#js-ai-assistant-panel');
        this._openButton = document.querySelector('#js-open-ai-assistant');
        this._closeButton = document.querySelector('#js-ai-assistant-close');
        this._animatedIcon = document.querySelector('#js-ai-animated-icon');
        this._animationInterval = null;

        if (!this._panel) return;

        this._overlay = this._panel.querySelector('.ai-assistant-panel__overlay');

        this._init();
    }

    /* ----------------------------------------
        Open Panel
    ---------------------------------------- */

    _openPanel() {
        if (!this._panel) return;

        this._panel.classList.add('is-open');
        document.body.classList.add('is-locked');
        document.body.style.overflow = 'hidden';
    }

    /* ----------------------------------------
        Close Panel
    ---------------------------------------- */

    _closePanel() {
        if (!this._panel) return;

        this._panel.classList.remove('is-open');
        document.body.classList.remove('is-locked');
        document.body.style.overflow = '';
    }

    /* ----------------------------------------
        Start Animation
    ---------------------------------------- */

    _startAnimation() {
        if (!this._animatedIcon) return;

        const radaContainer = this._animatedIcon.querySelector('.rada-container');
        const radarMaskContainer = this._animatedIcon.querySelector('.radar-mask-container');

        if (radaContainer && radarMaskContainer) {
            // Start animation
            radaContainer.style.animation = 'radar-sweep 2s linear forwards';
            radarMaskContainer.style.animation = 'radar-reveal 2s linear forwards';
        }
    }

    /* ----------------------------------------
        Restart Animation
    ---------------------------------------- */

    _restartAnimation() {
        if (!this._animatedIcon) return;

        const radaContainer = this._animatedIcon.querySelector('.rada-container');
        const radarMaskContainer = this._animatedIcon.querySelector('.radar-mask-container');

        if (radaContainer && radarMaskContainer) {
            // Reset animation by removing and re-adding it
            radaContainer.style.animation = 'none';
            radarMaskContainer.style.animation = 'none';

            // Force reflow to ensure the reset is applied
            void radaContainer.offsetWidth;
            void radarMaskContainer.offsetWidth;

            // Re-apply animation
            radaContainer.style.animation = 'radar-sweep 2s linear forwards';
            radarMaskContainer.style.animation = 'radar-reveal 2s linear forwards';
        }
    }

    /* ----------------------------------------
        Initialize
    ---------------------------------------- */

    _init() {
        if (this._openButton) {
            setTimeout(() => {
                this._openButton.classList.add('is-visible');
                // Start animation when button becomes visible
                this._startAnimation();
            }, 2000);
        }

        if (this._animatedIcon) {
            const radaContainer = this._animatedIcon.querySelector('.rada-container');
            const radarMaskContainer = this._animatedIcon.querySelector('.radar-mask-container');

            if (radaContainer && radarMaskContainer) {
                // Restart animation every 50 seconds
                this._animationInterval = setInterval(() => {
                    this._restartAnimation();
                }, 50000);
            }
        }

        if (this._openButton) {
            this._openButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this._openPanel();
            });
        }

        if (this._closeButton) {
            this._closeButton.addEventListener('click', () => {
                this._closePanel();
            });
        }

        if (this._overlay) {
            this._overlay.addEventListener('click', () => {
                this._closePanel();
            });
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this._panel && this._panel.classList.contains('is-open')) {
                this._closePanel();
            }
        });
    }
}

